<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
    <div class="row">
        <div class="col-md-12">
            <div class="page-breadcrumb"><!-- new -->
                <ul class="page-breadcrumb__trail">
                    <li><a>Manage</a></li>
                    <li><a>Ponds</a></li>
                </ul>
                <div class="page-breadcrumb__icons">
                    <a routerLink="/home"><img src="assets/images/New_Icons/home-transprent-icon.svg" title="Home"
                            alt="Home icon"></a>
                </div>
            </div>
            <div class="block">
                <div class="page-header"> <!--changed new-->
                    <span class="page-header__title">Ponds</span>
                    <img src="assets/images/New_Icons/refresh-icon.svg" alt="Refresh icon" title="Refresh"
                        class="page-header__icon" width="17" height="17"
                        (click)="!enableDisablePageLoader ? ngOnInit() : null" />
                </div>
                <div class="list_block">
                    <div class="toolbar"> <!--search and new changed new-->
                        <div class="toolbar__search">
                            <img src="../../../../../../assets/images/New_Icons/search-icon.svg" alt="Search icon">
                            <input type="text" (ngModelChange)="onSearchChanged()" [(ngModel)]="search" name="search"
                                autocomplete="off" placeholder="Search by pond" />
                        </div>
                        <div class="toolbar__spacer"></div>
                        <div class="toolbar__add-button" (click)="openForm()">
                            <button type="button">
                                <span class="toolbar__add-icon">
                                    <img src="../../../../../../assets/images/New_Icons/plus-icon.svg" alt="Add Icon" />
                                </span>
                                <span class="toolbar__add-text">Add New</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div *ngIf="enableDisablePageLoader">
                    <div class="adjust">
                        <div class="loader2"></div>
                    </div>
                </div>
                <div class="cards_container" *ngIf="!enableDisablePageLoader">
                    <div class="card_wrapper" *ngFor="let pond of pondsList; let i = index">
                        <div class="master-card">
                            <div class="master-card-header">
                                <div class="master-card-title">
                                    <img src="../../../../../../assets/images/New_Icons/card-heading.svg"
                                        alt="Left arrow icon">
                                    <span>{{ pond && pond.name }}</span>
                                </div>
                            </div>
                            <div class="master-card-body">
                                <div class="master-card-body-info">
                                    <span class="card-content-text">Location:</span>
                                    <span class="text">{{ pond.farmsiteDetails?.farmNameAtLocation }}</span>
                                </div>
                                <div class="master-card-body-info">
                                    <span class="card-content-text">Section:</span>
                                    <span class="text">{{ pond.section?.section_name }}</span>
                                </div>
                                <div class="master-card-body-info">
                                    <span class="card-content-text">Pond type:</span>
                                    <span class="text">{{ pond.PondType?.name }}</span>
                                </div>
                                <div class="master-card-body-info">
                                    <span class="card-content-text">Pond usage:</span>
                                    <span class="text">{{ pond.PondUsage?.name }}</span>
                                </div>
                                <div class="master-card-body-info">
                                    <span class="card-content-text">Created At:</span>
                                    <span class="text">{{ pond?.createdAt | date: "dd MMM yyyy" }}</span>
                                </div>
                            </div>
                            <div class="master-card-footer">
                                <div class="master-card-footer-info">
                                    <span class="label">Updated At:</span>
                                    <span class="text">{{ pond?.updatedAt | date: "dd MMM yyyy" }}</span>
                                </div>
                                <div class="action-icons">
                                    <a>
                                        <img src="../../../../../../assets/images/New_Icons/edit.svg" alt="Edit icon"
                                            title="Edit Business Type" (click)="getPondById(pond.id)">
                                    </a>
                                     <!-- <a style="padding: 10px;">
                                        <img src="../../../../../../../assets/images/New_Icons/delete-icon.svg" class="activities_images" title="Delete Pond" (click)="getPondRelatedData(pond.id)">
                                    </a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="listLoader" class="loader-div">
                    <div class="adjust">
                        <div class="loader2 list-loader"></div>
                    </div>
                </div>
                <div *ngIf="noList && !enableDisablePageLoader" class="noDataFoundMessage">Pond Not Found</div>
                <!--sensor types block end-->
            </div>
            <!--add/update form-->
            <div class="dynamic-form-wrapper"
                [ngClass]="{ 'floating-panel': formFieldCount <= 7, 'slide-in-overlay': formFieldCount > 7}"
                *ngIf="showAddEditForm">
                <!--<div *ngIf="formFieldCount > 7" class="overlay-background" (click)="closeForm()"></div>-->
                <!--outside close-->
                <div class="popup-wrapper">
                    <button type="button" class="popup-close-beside" (click)="clear()" title="Close">&times;</button>
                    <!-- Actual Popup -->
                    <div [ngClass]="{ 'form-container-panel': formFieldCount > 7, 'popup-inner': formFieldCount <= 7}">
                        <form [formGroup]="registerForm" novalidate>
                            <div class="form-header">
                                <div class="form-title">Pond</div>
                                <button class="add-update-submit-button" (click)="addUpdatePond()"
                                    [disabled]="sensorDoubleClick">
                                    <span class="icon"><img
                                            src="../../../../../../assets/images/New_Icons/tick-icon.svg"
                                            alt="Tick icon"></span>
                                    <span class="text">{{ submitButton ? 'Submit' : 'Update' }}</span>
                                </button>
                            </div>
                            <div class="form-container">
                                <div class="form-section">
                                    <div class="grid-three-cols">
                                        <!--Name-->
                                        <mat-form-field appearance="outline" class="w-100">
                                            <mat-label>Pond</mat-label>
                                            <input matInput id="name" type="text" formControlName="name"
                                                autocomplete="off" placeholder="Enter name" />
                                            <!-- Hint -->
                                            <mat-hint><i>3–20 alphabetic characters</i></mat-hint>
                                            <!-- Single dynamic error -->
                                            <mat-error
                                                *ngIf="(f.name.dirty || f.name.touched || submitted) && f.name.errors">
                                                <i> {{f.name.hasError('required') ? 'Name is required.':
                                                    f.name.hasError('minlength')? 'Minimum 3 characters required.':
                                                    f.name.hasError('maxlength')
                                                    ? 'Maximum 20 characters allowed.' : f.name.hasError('pattern') ?
                                                    'Only alphabets allowed.': ''}}</i>
                                            </mat-error>
                                        </mat-form-field>

                                        <!--Section-->
                                        <mat-form-field appearance="outline" class="w-100">
                                            <mat-label>Section</mat-label>
                                            <mat-select formControlName="section_id">
                                                <mat-option value="undefined" disabled>Select Section</mat-option>
                                                <mat-option *ngFor="let sec of sections" [value]="sec.id">{{
                                                    sec.section_name
                                                    }}</mat-option>
                                            </mat-select>
                                            <mat-hint *ngIf="f.section_id.invalid"><i>Select section</i></mat-hint>
                                            <mat-hint *ngIf="f.section_id.valid"><i>Section selected</i></mat-hint>
                                            <mat-error
                                                *ngIf="submitted && f.section_id.hasError('required')">Required.</mat-error>
                                        </mat-form-field>

                                        <!-- Tank Code -->
                                        <mat-form-field appearance="outline" class="w-100">
                                            <mat-label>Code</mat-label>
                                            <input matInput id="tankcode" type="text" formControlName="code"
                                                autocomplete="off" placeholder="Enter tank code" />
                                            <mat-hint><i>3–20 alphanumeric characters</i></mat-hint>
                                            <mat-error
                                                *ngIf="(f.code.dirty || f.code.touched || submitted) && f.code.errors">
                                                <i>
                                                    {{ f.code.hasError('required') ? 'Tank code is required.' :
                                                    f.code.hasError('minlength') ? 'Minimum 3 characters required.'
                                                    : f.code.hasError('maxlength') ? 'Maximum 20 characters allowed.' :
                                                    f.code.hasError('pattern') ? 'Digits/letters only.' : ''}}
                                                </i>
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <!-- ── Section: Tank Classification ── -->
                                <div class="form-section">
                                    <h3 class="section-title">Classifications</h3>
                                    <div class="grid-three-cols">
                                        <!-- Pond Type -->
                                        <mat-form-field appearance="outline" class="w-100">
                                            <mat-label>Pond Type</mat-label>
                                            <mat-select formControlName="pond_type_id">
                                                <mat-option value="undefined" disabled>Select Pond Type</mat-option>
                                                <mat-option *ngFor="let m of pondtypes" [value]="m.id">{{ m.name
                                                    }}</mat-option>
                                            </mat-select>
                                            <mat-hint *ngIf="f.pond_type_id.invalid"><i>Select tank
                                                    make</i></mat-hint>
                                            <mat-hint *ngIf="f.pond_type_id.valid"><i>Pond type
                                                    selected</i></mat-hint>
                                            <mat-error
                                                *ngIf="submitted && f.pond_type_id.hasError('required')">Required.</mat-error>
                                        </mat-form-field>

                                        <!-- Pond Usage -->
                                        <mat-form-field appearance="outline" class="w-100">
                                            <mat-label>Pond Usage</mat-label>
                                            <mat-select formControlName="ponduse_id">
                                                <mat-option value="undefined" disabled>Select Pond Usage</mat-option>
                                                <mat-option *ngFor="let u of pondUsages" [value]="u.id">{{ u.name
                                                    }}</mat-option>
                                            </mat-select>
                                            <mat-hint *ngIf="f.ponduse_id.invalid"><i>Select pond
                                                    usage</i></mat-hint>
                                            <mat-hint *ngIf="f.ponduse_id.valid"><i>Pond usage
                                                    selected</i></mat-hint>
                                            <mat-error
                                                *ngIf="submitted && f.ponduse_id.hasError('required')">Required.</mat-error>
                                        </mat-form-field>

                                        <!--Aerators-->
                                        <mat-form-field appearance="outline" class="w-100">
                                            <mat-label>No of Aerators</mat-label>
                                            <input matInput id="tankbreadth" formControlName="number_of_aerators"
                                                autocomplete="off" placeholder="Breadth in ft" />
                                            <mat-hint><i>Decimal allowed</i></mat-hint>
                                            <mat-error
                                                *ngIf="(submitted || f.number_of_aerators.touched || f.number_of_aerators.dirty) && f.number_of_aerators.hasError('pattern')">
                                                <i>Invalid value.</i>
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="form-field" [ngClass]="{'disbledCls': updateButton}">
                                  <p class="form-field barcode_hint">Use following barcode to add pond: {{ this.barcodes[0]?.barcode_from }} To {{ this.barcodes[0]?.barcode_to }}</p>
                                </div>
                                <div class="form-section">
                                    <div class="grid-three-cols">
                                        <!-- TANK BARCODE -->
                                        <mat-form-field appearance="outline" class="w-100"
                                            [ngClass]="{ disbledCls: updateButton }">
                                            <mat-label>Tank Barcode</mat-label>
                                            <input matInput id="tankbarcode" formControlName="barcode"
                                                autocomplete="off" placeholder="Enter barcode" />
                                            <mat-hint><i>4-digit code</i></mat-hint>
                                            <mat-error *ngIf="(submitted || f.barcode.touched || f.barcode.dirty)">
                                                <ng-container
                                                    *ngIf="f.barcode.hasError('required')">Required.</ng-container>
                                                <ng-container *ngIf="f.barcode.hasError('minlength')">Min 4
                                                    chars.</ng-container>
                                                <ng-container *ngIf="f.barcode.hasError('maxlength')">Max 4
                                                    chars.</ng-container>
                                                <ng-container *ngIf="f.barcode.hasError('pattern')">Digits
                                                    only.</ng-container>
                                            </mat-error>
                                        </mat-form-field>

                                        <!-- TANK STATUS -->
                                        <mat-form-field appearance="outline" class="w-100">
                                            <mat-label>Tank Status</mat-label>
                                            <input matInput id="tankstatus" formControlName="status" autocomplete="off"
                                                placeholder="Eg: Active" />
                                            <mat-hint><i>Up to 10 chars</i></mat-hint>
                                            <mat-error *ngIf="(submitted || f.status.touched || f.status.dirty)">
                                                <ng-container *ngIf="f.status.hasError('maxlength')">Max 10
                                                    chars.</ng-container>
                                                <ng-container *ngIf="f.status.hasError('pattern')">Invalid
                                                    chars.</ng-container>
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <!--add/update form end-->
            <div class="dynamic-form-wrapper" [ngClass]="{ 'floating-panel': 3 <= 7, 'slide-in-overlay': 3 > 7}" *ngIf="showDeleteForm">
                <!--<div *ngIf="formFieldCount > 7" class="overlay-background" (click)="closeForm()"></div>-->
                <!--outside close-->
                <div class="popup-wrapper">
                <button type="button" class="popup-close-beside" (click)="clearDeletePondPopup()" title="Close">&times;</button>
                <!-- Actual Popup -->
                <div [ngClass]="{ 'form-container-panel': 3 > 7, 'popup-inner': 3 <= 7}">
                    <div class="form-header">
                        <div class="form-title">Pond</div>
                        <button class="add-update-submit-button" (click)="deletePond()">
                        <span class="icon"><img src="../../../../../../assets/images/New_Icons/tick-icon.svg"></span>
                        <span class="text">Delete</span>
                        </button>
                    </div>
                    <div class="form-container">
                        <mat-radio-group [(ngModel)]="selectedDeletedataType" name="deleteType" class="d-block">
                        <mat-radio-button class="d-block" [value]="'False'">
                            <label>Delete Culture Data</label>
                        </mat-radio-button>

                        <mat-radio-button class="d-block" [value]="'True'">
                            <label>Delete Culture Data && Pond</label>
                        </mat-radio-button>
                        </mat-radio-group>
                        <div style="margin-top: 1rem;padding-left: 1rem;">
                        <h3 style="margin-bottom: 1rem;font-size: medium;font-weight: 500;">Pond Details: </h3>
                        <ul class="deletepondData" *ngFor="let list of imageDetails">
                            <li>Meal records: {{ list.meals }}</li>
                            <li>Check tray Records: {{ list.check_tray }}</li>
                            <li>Sampling Records: {{ list.sampling }}</li>
                            <li>Harvest Records: {{ list.harvest }}</li>
                            <li>Observation Records: {{ list.observation }}</li>
                            <li>Water Quality Records: {{ list.water_quality }}</li>
                        </ul>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
</div>
